/**
 * If [version1] is bigger than [version2] it will return true
 * Otherwise it will return false
 *
 * @param version1
 * @param version2
 * @returns
 */
function appVersionIsBigger(version1 = "1.0.0", version2 = "1.0.0"): boolean {
  const sanitizedVersion1 = version1.replace("v", "");
  const sanitizedVersion2 = version2.replace("v", "");
  const compareResult = sanitizedVersion1.localeCompare(sanitizedVersion2, undefined, {
    numeric: true,
    sensitivity: "base",
  });

  if (compareResult === 0) return false;
  if (compareResult === -1) return false;

  return true;
}

export default appVersionIsBigger;
